module.exports = __webpack_public_path__ + "img/banner-default.5745e6ca.png";